import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Home from "../views/layout/Index.vue";
import Qr from "../views/qr/qr.vue";

Vue.use(VueRouter)

const routes = [{
        path: "/qr",
        name: "qr",
        meta: {
            title: '可信时间戳知识产权保护平台_联合信任时间戳服务中心',
        },
        component: Qr,
    },
    {
        path: '/',
        name: 'Index',
        meta: {
            title: '可信时间戳知识产权保护平台_联合信任时间戳服务中心',
        },
        component: Index
    },
    {
        path: "/time",
        name: "time",
        component: Home,
        redirect:'/time/ApplyTime',
        children: [
            {
                path: "/time/ApplyTime",
                name: "ApplyTime",
                meta: {
                    icon: 'vant-ali-shenqing',
                    model: 'time',
                    name: '申请',
                    title: '申请文件/数据认证',
                },
                component: () =>
                    import ( /* webpackChunkName: "ApplyTime" */ '../views/time/ApplyTime.vue'),
            },
            {
                path: "/time/ApplyResult",
                name: "ApplyResult",
                meta: {
                    model: 'time',
                    title: '申请文件/数据认证成功',
                },
                component: () =>
                    import ( /* webpackChunkName: "ApplyResult" */ '../views/time/ApplyResult.vue'),
            },
            {
                path: "/verify/Index",
                name: "Verify",
                meta: {
                    model: 'verify',
                    name: '验证',
                    icon: 'vant-ali-yanzhengyanzhengma',
                },
                component: () =>
                    import ( /* webpackChunkName: "Verify" */ '../views/verify/Index.vue'),
            },
            {
                path: "/file/ProtectFile",
                name: "ProtectFile",
                meta: {
                    keepAlive: true,
                    isTab: true,
                    icon: 'vant-ali-wenjian',
                    model: 'file',
                    name: '文件',
                    title: '已认证文件',
                },
                component: () =>
                    import ( /* webpackChunkName: "ProtectFile" */ '../views/file/ProtectFile.vue'),
            },
            {
                path: "/file/FileDetail",
                name: "FileDetail",
                meta: {
                    model: 'file',
                    title: '已认证文件详情',
                },
                component: () =>
                    import ( /* webpackChunkName: "FileDetail" */ '../views/file/FileDetail.vue'),
            },
            {
                path: "/mine/MyInfo",
                name: "MyInfo",
                meta: {
                    icon: 'vant-ali-wode',
                    model: 'mine',
                    name: '我的',
                    title: '我的',
                },
                component: () =>
                    import ( /* webpackChunkName: "MyInfo" */ '../views/mine/MyInfo'),
            },
            {
                path: "/mine/Account",
                name: "Account",
                meta: {
                    name: '我的',
                },
                component: () =>
                    import ( /* webpackChunkName: "Verify" */ '../views/mine/Account.vue'),
            },
        ],
    },
    {
        path: "copyright",
        name: "Copyright",
        redirect: "/copyright/index",
        component: Home,
        children: [
            {
                path: '/copyright/index',
                name: 'CopyrightIndex',
                component: () => import( /* webpackChunkName: "CopyrightComponent" */ "../views/copyright/copyright/index.vue"),
                meta: {
                    title: "申请版权（著作权）认证",
                    titleEn:'作品版权认证',
                    subTitle: "",
                    keepAlive: false,
                    model: 'apply',
                },
            },
            {
                path: '/copyright/copyrightSecond',
                name: 'CopyrightSecond',
                component: () => import( /* webpackChunkName: "CopyrightSecondComponent" */ "../views/copyright/copyrightSecond/index.vue"),
                meta: {
                    title: "申请版权（著作权）认证",
                    titleEn:'作品版权认证',
                    subTitle: "",
                    keepAlive: false,
                    model: 'apply',
                },
            },
            {
                path: '/copyright/copyrightThird',
                name: 'CopyrightThird',
                component: () => import( /* webpackChunkName: "CopyrightThirdComponent" */ "../views/copyright/copyrightThird/index.vue"),
                meta: {
                    title: "申请版权（著作权）认证",
                    titleEn:'作品版权认证',
                    subTitle: "",
                    keepAlive: false,
                    model: 'apply',
                },
            },
            {
                path: '/copyright/copyrightAuthSuccess',
                name: 'CopyrightAuthSuccess',
                component: () => import( /* webpackChunkName: "CopyrightAuthSuccessComponent" */ "../views/copyright/copyrightAuthSuccess/index.vue"),
                meta: {
                    title: "申请版权（著作权）认证",
                    titleEn:'作品版权认证',
                    subTitle: "",
                    keepAlive: false,
                    model: 'apply',
                },
            },
            {
                path: '/copyright/copyrightAuthDetail',
                name: 'CopyrightAuthDetail',
                component: () => import( /* webpackChunkName: "CopyrightAuthDetailComponent" */ "../views/copyright/copyrightAuthDetail/index.vue"),
                meta: {
                    title: "已认证作品",
                    titleEn:'已认证作品',
                    subTitle: "",
                    keepAlive: false,
                    model: 'work',
                },
            },
            {
                path: '/copyright/certifiedWork',
                name: 'CertifiedWork',
                component: () => import( /* webpackChunkName: "CertifiedWorkComponent" */ "../views/copyright/certifiedWork/index.vue"),
                meta: {
                    title: "已认证作品",
                    titleEn:'已认证作品',
                    subTitle: "",
                    keepAlive: false,
                    model: 'work',
                },
            },
            {
                path: '/copyright/myDraft',
                name: 'MyDraft',
                component: () => import( /* webpackChunkName: "MyDraftComponent" */ "../views/copyright/myDraft/index.vue"),
                meta: {
                    title: "作品草稿箱",
                    titleEn:'作品草稿箱',
                    subTitle: "",
                    keepAlive: false,
                    model: 'draft',
                },
            },
            {
                path: '/copyright/drama',
                name: 'DramaIndex',
                component: () => import( /* webpackChunkName: "MyDraftComponent" */ "../views/copyright/drama/index.vue"),
                meta: {
                    title: "申请版权（著作权）认证",
                    titleEn:'作品版权认证',
                    subTitle: "",
                    keepAlive: false,
                    model: 'apply',
                },
            }
        ],
    },
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});

export default router